<template>
  <div>
    <Header />
    <main role="main">
      <b-container class="user py-3">
        <b-row>
          <b-col md="3">
            <div class="box">
              <div class="user__avatar text-center py-5">
                <b-img :src="require('@/assets/images/default_avatar.png')" rounded="circle" alt="Circle image"></b-img>
                <h4 class="mt-3">{{ user.name }}</h4>
                <h6 class="mt-3 user__avatar_email">{{ user.email }}</h6>
              </div>
            </div>
            <div class="box">
              <div class="user__balance text-center py-3">
                <b-img :src="require('@/assets/images/ic_wallet.png')" width="72" rounded="circle" alt="Circle image"></b-img>
                <Wallet :size="24" color="rgb(33, 37, 41)" />
                <b-link :to="{ name: 'user-topup' }" class="btn__normal">Nạp thêm tiền</b-link>
              </div>
            </div>
            <div class="box">
              <div class="user_profile">
                <b-link :to="{ name: 'user-profile' }" :active="$route.name == 'user-profile'" class="user__link"><fa-icon icon="user-circle" /> Thông tin cá nhân <fa-icon icon="angle-double-right" class="float-right" /></b-link>
              </div>
            </div>
            <div class="box">
              <div class="user_activity">
                <b-link :to="{ name: 'user-activity' }" :active="$route.name == 'user-activity'" class="user__link"><fa-icon icon="history" /> Lịch sử giao dịch <fa-icon icon="angle-double-right" class="float-right" /></b-link>
              </div>
            </div>
          </b-col>
          <b-col md="9">
            <slot />
          </b-col>
        </b-row>
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Wallet from '@/components/widgets/Wallet'
import { mapState } from 'vuex'

export default {
  components: {
    Header,
    Footer,
    Wallet
  },
  computed: {
    ...mapState('auth', ['user'])
  }
}
</script>